/* Behaviour for sections/main-product.liquid (default and request-a-quote product templates).
   One implementation for tabs, accordions, the 'viewing' counter, the thumbnail
   strip and the product modal. Runs deferred, after global.js (ModalDialog) and jQuery. */
(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn();
  }

  /* Description/specification tabs. */
  function initTabs() {
    document.querySelectorAll('.product-single__description ul.tabs').forEach(function (list) {
      var links = Array.prototype.slice.call(list.querySelectorAll('a'));
      if (!links.length) return;
      function activate(link) {
        links.forEach(function (l) {
          var panel = document.querySelector(l.getAttribute('href'));
          var on = l === link;
          l.classList.toggle('active', on);
          if (panel) panel.style.display = on ? '' : 'none';
        });
      }
      links.forEach(function (l) {
        l.addEventListener('click', function (e) { e.preventDefault(); activate(l); });
      });
      activate(links[0]);
    });
  }

  /* Legacy accordion (jQuery slideToggle, behaviour unchanged). */
  function initAccordion() {
    if (!window.jQuery) return;
    window.jQuery('.product__accordion summary').on('click', function (event) {
      event.stopPropagation();
      window.jQuery(this).closest('div').find('.accordion__content').slideToggle(200);
      window.jQuery(this).closest('div').toggleClass('active');
    });
  }

  /* rf accordion (max-height animation). */
  function initRfAccordion() {
    document.querySelectorAll('.rf-product__accordion').forEach(function (acc) {
      var trigger = acc.querySelector('summary') || acc.querySelector('.summary__title') || acc;
      var content = acc.querySelector('.rf-accordion__content');
      if (!content || !trigger) return;
      var active = content.classList.contains('active');
      content.style.maxHeight = active ? content.scrollHeight + 'px' : '0px';
      content.setAttribute('aria-hidden', active ? 'false' : 'true');
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var opened = content.classList.toggle('active');
        content.style.maxHeight = opened ? content.scrollHeight + 'px' : '0px';
        content.setAttribute('aria-hidden', opened ? 'false' : 'true');
        acc.classList.toggle('open', opened);
      });
      new ResizeObserver(function () {
        if (content.classList.contains('active')) content.style.maxHeight = content.scrollHeight + 'px';
      }).observe(content);
    });
  }

  /* 'X people are viewing this' counter; only when the block is present. */
  function initLiveView() {
    var el = document.querySelector('.live-view');
    if (!el) return;
    var min = parseInt(el.dataset.min, 10), max = parseInt(el.dataset.max, 10), every = parseInt(el.dataset.interval, 10);
    if (isNaN(min) || isNaN(max) || !(every > 0)) return;
    setInterval(function () { el.textContent = Math.floor(Math.random() * (max - min + 1) + min); }, every);
  }

  onReady(function () { initTabs(); initAccordion(); initRfAccordion(); initLiveView(); });
})();

// Thumbnail strip: a thumbnail scrolls the gallery slider to its slide, and the active
  // thumbnail follows the slider when it moves by arrows (assets/slider.js) or by swiping.
  (function initStThumbnails() {
    function setup() {
      document.querySelectorAll('[data-st-thumbnails]').forEach(function (strip) {
        var wrapper = strip.closest('.product__media-wrapper');
        if (!wrapper) return;
        var slider = wrapper.querySelector('.product__media-list');
        if (!slider) return;

        var buttons = strip.querySelectorAll('[data-st-thumb-index]');

        function markActive(index) {
          buttons.forEach(function (b) {
            b.classList.toggle('is-active', Number(b.dataset.stThumbIndex) === index);
          });
        }

        // Jump without animation: a smooth scroll on this scroll-snap list can be cut
        // short by the snap container.
        function scrollToIndex(i) {
          var slide = slider.children[i];
          if (!slide) return;
          var previous = slider.style.scrollBehavior;
          slider.style.scrollBehavior = 'auto';
          slider.scrollLeft = slide.clientWidth * i;
          slider.style.scrollBehavior = previous;
        }

        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var i = Number(btn.dataset.stThumbIndex);
            scrollToIndex(i);
            markActive(i);
          });
        });

        // Follow along when the visitor swipes or uses the arrows.
        var raf;
        slider.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var w = slider.children[0] ? slider.children[0].clientWidth : 0;
            if (!w) return;
            markActive(Math.round(slider.scrollLeft / w));
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
  })();

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);
